export default __webpack_public_path__ + "static/pay_compare_comp1_inactive-ea4082a9f80e75adacde7fbf61f69af8.png";